var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChair(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.58562 3.5C5.31762 3.964 5.31762 4.58667 5.31762 5.83333V7.85133C5.60429 7.83333 5.92696 7.83333 6.27429 7.83333H11.0276C11.3743 7.83333 11.6976 7.83333 11.9843 7.85133V5.83333C11.9843 4.58667 11.9843 3.964 11.7163 3.5C11.5408 3.19599 11.2883 2.94353 10.9843 2.768C10.5203 2.5 9.89762 2.5 8.65096 2.5C7.40429 2.5 6.78162 2.5 6.31762 2.768C6.01361 2.94353 5.76115 3.19599 5.58562 3.5ZM4.81762 11.1607C4.48296 11.1473 4.28029 11.102 4.14162 10.9507C3.94362 10.7347 3.96962 10.4347 4.02162 9.834C4.05829 9.40067 4.14229 9.10867 4.33296 8.89067C4.67429 8.5 5.22296 8.5 6.32096 8.5H10.981C12.079 8.5 12.6276 8.5 12.969 8.89067C13.1596 9.108 13.2436 9.4 13.281 9.834C13.3323 10.434 13.3583 10.7347 13.1603 10.9507C13.0216 11.102 12.819 11.1473 12.4843 11.1607V14.5C12.4843 14.6326 12.4316 14.7598 12.3378 14.8536C12.2441 14.9473 12.1169 15 11.9843 15C11.8517 15 11.7245 14.9473 11.6307 14.8536C11.537 14.7598 11.4843 14.6326 11.4843 14.5V11.1667H5.81762V14.5C5.81762 14.6326 5.76495 14.7598 5.67118 14.8536C5.57741 14.9473 5.45023 15 5.31762 15C5.18502 15 5.05784 14.9473 4.96407 14.8536C4.8703 14.7598 4.81762 14.6326 4.81762 14.5V11.1607Z",
    fill: "#E5E5E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChair);
export default __webpack_public_path__ + "static/media/chair.1b6106c351ebde8dbcd9cc68b8de06a6.svg";
export { ForwardRef as ReactComponent };